module.exports = __webpack_public_path__ + "static/media/quiz_background_pdf.48ac4412.png";